import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

interface ImportLoadingModalProps {
  open: boolean;
}

const ImportLoadingModal: React.FC<ImportLoadingModalProps> = ({ open }) => {
  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            py: 4,
          }}
        >
          <CircularProgress size={48} sx={{ mb: 2 }} />
          <Typography variant="h6" gutterBottom>
            Preparing Import
          </Typography>
          <Typography variant="body2" color="text.secondary" align="center">
            Please wait while we prepare to import your content...
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ImportLoadingModal;
